import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
    is_open: true,
    hours: [
        { days: "Mon - Sat", open: "11:00 AM", close: "8:00 PM" },
        { days: "Sun", open: "10:00 AM", close: "7:00 PM" },
    ],
    hero_image_url: "https://images.pexels.com/photos/30541218/pexels-photo-30541218.jpeg",
    hero_overlay_opacity: 0.55,
    hero_presets: [],
    gallery_images: [],
    about_image_url: "",
    about: {
        title_en: "",
        title_es: "",
        body_en: "",
        body_es: "",
        quote_en: "",
        quote_es: "",
        quote_author: "",
        stats: [],
    },
};

export default function useSiteSettings() {
    const [settings, setSettings] = useState(DEFAULTS);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        const fetchOnce = () =>
            api
                .get("/settings")
                .then((r) => alive && setSettings({ ...DEFAULTS, ...r.data }))
                .catch(() => {})
                .finally(() => alive && setLoading(false));
        fetchOnce();
        // refresh every 60s so changes from admin propagate without a hard reload
        const id = setInterval(fetchOnce, 60000);
        return () => {
            alive = false;
            clearInterval(id);
        };
    }, []);

    return { settings, loading };
}
